/** The « from … » complement of a generation sentence: « d’aucun élément », « de l’élément », « des 3 éléments ». */
const describeElementsSource = (elementCount: number): string => {
	if (elementCount === 0) {
		return 'd’aucun élément';
	}

	return elementCount === 1 ? 'de l’élément' : `des ${elementCount} éléments`;
};

export default describeElementsSource;
